import { useWizard } from "react-use-wizard";
import buySteps from "../../buySteps";
import { TKeyOfDataWizardBuy, TStringKeysOfIFillDataWizardBuy } from "../../..";
import TimeIntervalStep from "../../../../../../../shared/wizard/steps/timeIntervalStep";
import { EDealRequestTimeInterval } from "../../../../../../../shared/wizard/steps/types";

interface IWishSwapStepBuy_4 {
  onChange: (data: string, key: TStringKeysOfIFillDataWizardBuy) => void;
  data: EDealRequestTimeInterval | null;
  isNextStepDisabled: boolean;
  onReset: (key: TKeyOfDataWizardBuy[]) => void;
}

const WishSwapStepBuy_4 = ({
  data,
  isNextStepDisabled,
  onChange,
  onReset,
}: IWishSwapStepBuy_4) => {
  const { goToStep } = useWizard();

  const handlePrevStep = () => {
    goToStep(buySteps.wishesSteps.swap.step_3);
    onReset(["timeIntervalTypeCommunication"]);
  };

  const handleNexStep = () => {
    goToStep(buySteps.wishesSteps.swap.step_5);
  };

  return (
    <div>
      <TimeIntervalStep
        handlePrevStep={handlePrevStep}
        handleNexStep={handleNexStep}
        onChange={onChange}
        isNextStepDisabled={isNextStepDisabled}
        data={data}
        mode="communication"
        text="Удобное время для связи:"
      />
    </div>
  );
};

export default WishSwapStepBuy_4;
